module.exports = __webpack_public_path__ + "img/pegasus.54a6ade2.png";